import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {Object} State */
const initialState = null;

const error = (_, { payload }) => payload;

const clear = () => null;

export default createReducer(initialState, {
  [types.FETCH_QUESTION_MODEL]: clear,
  [types.FETCH_QUESTION_MODEL_FAILURE]: error,
});
